import { createSelector } from 'reselect';

const getUserInfo = state => state.user;
const getUserId = state => state.id;

const getUserData = createSelector([getUserInfo], userInfo => userInfo.user.data);

export { getUserId, getUserInfo, getUserData };
